import { TrashCan } from "@carbon/icons-react";
import { CopyButton, SwitchAppIconButton } from "../../components";
import { bankAccountConstants } from "../../constants";
import { IAccountDetailsWithCopyButtonProps } from "./AccountDetailsWithCopyButton";
import { TopUpAccount } from "./TopUpAccount";

export const View = (
  props: IAccountDetailsWithCopyButtonProps
  //  & {
  //   deallocateTopUpAccountById: () => void;
  //   isLoadingDeallocateTopUpAccountById: boolean;
  // }
) => {
  const isRenderedInIframe = window.self !== window.top;

  return (
    <div className="account-details--container flex-container row justify-content--center align-items--center">
      {props.accounts_list.map((acc, index) => {
        const isMonniePointAccountNumber =
          acc.bank_code === bankAccountConstants.MONNIEPOINT_BANK_CODE;
        const monniePointPriorityClassname = isMonniePointAccountNumber
          ? "monniepoint-account"
          : "";

        return (
          <div
            key={acc.bank_code}
            className={`bankaccount-container bordered pl-5 pr-5 pt-5 pb-5 b-r-5 mt-5 mb-5 mr-5 animated-item-${index} ${monniePointPriorityClassname}`}
          >
            <TopUpAccount {...acc} />
          </div>
        );
      })}
    </div>
  );
};
